import { render } from "./LayoutCoupon.vue?vue&type=template&id=cf77611c&ts=true"
import script from "./LayoutCoupon.vue?vue&type=script&lang=ts"
export * from "./LayoutCoupon.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__